
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface DurationSelectorProps {
  selectedHours: string;
  onDurationChange: (value: string) => void;
}

const DurationSelector = ({ selectedHours, onDurationChange }: DurationSelectorProps) => {
  // Generate duration options from 0.5 to 24 hours with 0.5 hour increments
  const generateDurationOptions = () => {
    const options = [];
    for (let hours = 0.5; hours <= 24; hours += 0.5) {
      options.push(hours);
    }
    return options;
  };

  // Format the duration display text
  const formatDurationText = (hours: number) => {
    if (hours === 0.5) {
      return "30 minutes";
    } else if (hours === 1) {
      return "1 hour";
    } else if (hours % 1 === 0) {
      return `${hours} hours`;
    } else {
      const wholeHours = Math.floor(hours);
      return wholeHours === 0 
        ? "30 minutes" 
        : `${wholeHours} hour${wholeHours > 1 ? "s" : ""} 30 minutes`;
    }
  };

  return (
    <div className="space-y-2">
      <label className="text-sm font-medium">Duration</label>
      <Select value={selectedHours} onValueChange={onDurationChange}>
        <SelectTrigger>
          <SelectValue placeholder="Select duration" />
        </SelectTrigger>
        <SelectContent>
          {generateDurationOptions().map((hours) => (
            <SelectItem key={hours} value={hours.toString()}>
              {formatDurationText(hours)}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default DurationSelector;
